// extracted by mini-css-extract-plugin
export default {"menuLeft":"styles_menuLeft__oVogk","menuLeftActive":"styles_menuLeftActive__oIzrW","menuMobile":"styles_menuMobile__1tIdB","slidein":"styles_slidein__lFWmI"};